export default __webpack_public_path__ + "e57a59e49189229cc8dcbce6718f6e49.svg";